module.exports = __webpack_public_path__ + "static/media/craveably-creamy-dt-en.98419aef.jpg";